/* eslint-disable */
import React, { Fragment } from 'react'
import { ModalControl } from '@entrata/portals-common/lib/components'
import { ArrowRightSm } from '@entrata/portals-common/lib/icons'
import RetrieveQuoteDialog from './RetrieveQuoteDialog'

import styled from '@emotion/styled'


const StyledDiv = styled('div')`
  margin-top: 32px;
  margin-bottom: 32px;
  text-align: center;
`

const StyledP = styled('p')`
  color: ${({ theme }) => theme.secondary.base};
  display: block;
  font-family: ${({ theme }) => theme.fonts.light};
  font-size: 18px;
  font-weight: bold;
  padding: 2px 8px 2px 8px;
  margin: 0 auto;
`

const StyledButton = styled('button')`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.secondary.base};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.light};
  font-size: 18px;
  padding: 8px 8px 2px 8px;

  svg {
    padding-left: 16px;
  }
`
const StyledHr = styled('hr')`
  width: 96px;
  height: 1.6px;
`

const RetrieveQuoteCta = () => (
  <StyledDiv>
    <StyledP>Already have a quote?</StyledP>
    <StyledHr />
    <ModalControl>
      {({ onClick, ref, ...props }) => (
        <Fragment>
          <StyledButton onClick={onClick} ref={ref}>
            Retrieve Your Quote
          </StyledButton>
          <RetrieveQuoteDialog {...props} />
        </Fragment>
      )}
    </ModalControl>
  </StyledDiv>
)

export default RetrieveQuoteCta
